import React from "react";
import { dealTypes } from "_constants";
import moment from "moment";
import PropTypes from "prop-types";
import { proposalShape } from "shapes";

import Modal, { ModalBody, ModalFooter, ModalHeader } from "components/Modal";
import ProposalBody from "components/Posts/Proposal/ProposalBody";
import SubmitButton from "components/SubmitButton";
import TitledDropdown from "components/TitledDropdown";
import TitledText from "components/TitledText";
import Restricted from "utils/Restricted";
import Translate from "utils/translate";

import styles from "./ExecuteModal.css";

const { t } = new Translate("ExecuteModal");

const proposalLabelContent = (proposal) => {
  if (!proposal) return null;

  return `${t("proposal")} ${proposal.offering ? t("offered") : t("received")} ${t("on")} ${moment(
    proposal.createdAt
  ).format("L")}`;
};

const ProposalLabel = ({ proposal }) => proposalLabelContent(proposal);

export default class ExecuteModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExecuting: false,
      isInvalid: false,
      tenant: props.tenant,
      type: props.type,
      proposal: props.proposal,
    };

    this.handleExecute = this.handleExecute.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isExecuting: false,
      tenant: nextProps.tenant,
      type: nextProps.type,
    });
  }

  handleChange(key, val) {
    this.setState({ [key]: val });
  }

  handleClose() {
    if (this.state.isExecuting) return null;
    this.setState({ proposal: undefined, isInvalid: false });

    return this.props.onClose();
  }

  handleExecute() {
    const { proposal, tenant, type } = this.state;

    if (tenant) {
      this.setState({
        proposal: undefined,
        isInvalid: false,
        isExecuting: true,
      });
      this.props.onExecute({
        tenant,
        type,
        proposalID: proposal ? proposal.id : undefined,
      });
    } else {
      this.setState({ isInvalid: true });
    }
  }

  render() {
    const { isExecuting, isInvalid, proposal, tenant, type } = this.state;
    const { isOpen, proposals } = this.props;

    return (
      <div>
        <Modal isOpen={isOpen} onClose={this.handleClose}>
          <ModalHeader onClose={this.handleClose}>{t("header")}</ModalHeader>
          <ModalBody isInfo>{t("info")}</ModalBody>
          <ModalBody>
            <div className={styles.fields}>
              <TitledText
                isRequired={isInvalid}
                onInput={(val) => this.handleChange("tenant", val)}
                text={tenant}
                title={t("tenant")}
                isEdit
              />
              <TitledDropdown
                onSelect={(val) => this.handleChange("type", val)}
                selectedValue={type}
                title={t("reasonForMoving")}
                valueExtractor={(r) => t(`dealTypes.${r}`)}
                values={dealTypes}
                isEdit
              />

              <Restricted requiredPermissions="assets">
                <TitledDropdown
                  emptyText={t("emptyText.proposals")}
                  keyExtractor={(p) => p.id}
                  onSelect={(p) => this.handleChange("proposal", p)}
                  selectedValue={proposal}
                  title={t("proposal")}
                  valueExtractor={(p) => <ProposalLabel proposal={p} />}
                  values={proposals}
                  isEdit
                />
              </Restricted>
            </div>
          </ModalBody>
          <ModalBody>
            {proposal && <ProposalBody proposal={proposal} isBordered isExpanded />}
          </ModalBody>
          <ModalFooter>
            <SubmitButton
              isSubmitting={isExecuting}
              onSubmit={this.handleExecute}
              submitLabel={t("execute")}
              submittingLabel={t("executing")}
            />
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

ExecuteModal.propTypes = {
  proposals: PropTypes.arrayOf(PropTypes.shape(proposalShape)),
  proposal: PropTypes.shape(proposalShape),
  tenant: PropTypes.string,
  type: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onExecute: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

ExecuteModal.defaultProps = {
  proposals: [],
};
